export const PRODUCT = 'PRODUCT';
export const CATEGORY = 'CATEGORY';

export const scopes = [PRODUCT, CATEGORY];

export const label = {
	[PRODUCT]: 'Карточка товара',
	[CATEGORY]: 'Каталог',
};